export const POPULATE_PRODUCTS_LIST = 'POPULATE_PRODUCTS_LIST';
export const LOADING_PRODUCTS = 'LOADING_PRODUCTS';
export const PRODUCT_WITH_ID = 'PRODUCT_WITH_ID';
export const LOADING_FAVORITES = 'LOADING_FAVORITES';
export const POPULATE_FAVORITES = 'POPULATE_FAVORITES';
export const SIMILAR_PRODUCTS = 'SIMILAR_PRODUCTS';
export const PRODUCT_FILES = 'PRODUCT_FILES';
